
import storeDateSelectorResolve from '../../directive/store-date-selector/store-date-selector.resolve';

export default function routes($stateProvider) {
	$stateProvider
		.state('reviewsIndicatorsPage', {
			url: '/reviewsIndicators/:stores?startDate&endDate',
			template: require('./reviewsIndicators.html'),
			resolve: {
				...storeDateSelectorResolve,
				reviewsIndicators: ['reviewsIndicators', 'selectedStore', 'endDate', 'startDate', function (reviewsIndicators, selectedStore, endDate, startDate) {
					return reviewsIndicators.summary({
						stores: JSON.stringify(selectedStore.storeIds),
						startDate,
						endDate,
					});
				}]
			},
			controller: 'ReviewsIndicatorsController',
			controllerAs: 'reviewsIndicators'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/reviewsIndicators/reviewsIndicators.routes.js